import { useState, useEffect } from 'react';
import { Badge } from '../../ui/badge';
import { History, Loader2 } from 'lucide-react';

const formatDate = (iso) => {
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return iso;
  }
};

const ResetHistoryList = ({ api, source, courseId, refreshKey, showCourse = false }) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams();
    if (source) params.append('source', source);
    if (courseId) params.append('course_id', courseId);
    setLoading(true);
    api.get(`/progress-reset/history?${params}`)
      .then(res => setHistory(res.data.history || []))
      .catch(() => setHistory([]))
      .finally(() => setLoading(false));
  }, [api, source, courseId, refreshKey]);

  return (
    <div className="space-y-2" data-testid="reset-history-list">
      <p className="flex items-center gap-2 text-sm font-medium">
        <History className="h-4 w-4" /> Reset history
      </p>
      {loading ? (
        <Loader2 className="h-4 w-4 animate-spin text-muted-foreground" />
      ) : history.length === 0 ? (
        <p className="text-sm text-muted-foreground" data-testid="reset-history-empty">No resets yet</p>
      ) : (
        <div className="rounded-md border divide-y">
          {history.map(log => (
            <div key={log.id} className="p-3 text-sm space-y-1" data-testid={`reset-history-row-${log.id}`}>
              <div className="flex flex-wrap items-center gap-2">
                <Badge variant="outline">{log.scope === 'course' ? 'Entire course' : log.scope === 'assessments' ? `${log.items.length} assessment(s)` : `${log.items.length} item(s)`}</Badge>
                {showCourse && <span className="font-medium">{log.source_label} · {log.course_title}</span>}
                <span className="text-muted-foreground">
                  {log.scope === 'assessments' ? `Attempts reset · ${log.department}` : `${log.users_with_progress}/${log.selected_users} user(s) · ${log.department === 'all' ? 'All departments' : log.department}`}
                </span>
                <span className="ml-auto text-xs text-muted-foreground">{formatDate(log.created_at)}</span>
              </div>
              <p className="text-xs text-muted-foreground truncate">
                By {log.admin_name} · {log.items.join(', ')}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ResetHistoryList;
